export const deserialize = ({ position, ...node }, deeper) => {
  return {
    ...node,
    children: deeper(node),
  };
};
